/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const GraphMutationPreviewTreeNode = zod.object({
  afterDescription: zod.string().nullish(),
  afterLabel: zod.string().nullish(),
  afterValue: zod.unknown().optional(),
  beforeDescription: zod.string().nullish(),
  beforeLabel: zod.string().nullish(),
  beforeValue: zod.unknown().optional(),
  changeCount: zod.int(),
  children: zod.array(zod.unknown()),
  description: zod.string().nullish(),
  fieldKey: zod.string().nullish(),
  id: zod.string(),
  label: zod.string(),
  maxCount: zod.int().nullish(),
  minCount: zod.int().nullish(),
  occurredAt: zod.string().nullish(),
  operation: zod.enum(['create', 'edit', 'delete', 'unchanged']),
  position: zod.int().nullish(),
  reference: zod.boolean().optional(),
  typeName: zod.string().nullish(),
  valueType: zod.string().nullish(),
  variant: zod.enum(['TYPE', 'INSTANCE']),
});

export type GraphMutationPreviewTreeNode = zod.input<typeof GraphMutationPreviewTreeNode>;
export type GraphMutationPreviewTreeNodeOutput = zod.output<typeof GraphMutationPreviewTreeNode>;
